import { render, staticRenderFns } from "./BasicLableOperation.vue?vue&type=template&id=343d9385&"
import script from "./BasicLableOperation.vue?vue&type=script&lang=js&"
export * from "./BasicLableOperation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports